module.exports = __webpack_public_path__ + "img/wx.17531757.png";